var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fab",attrs:{"open":_vm.open},on:{"mouseenter":function($event){_vm.open = true},"mouseleave":function($event){_vm.open = false}}},[_c('div',{staticClass:"fab-inner"},[_vm._t("default")],2),_c('rkm-fab-item',{attrs:{"color":_vm.color,"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('click', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }